const WhoWeHelpContent = {
  title: "Who We Help",
  subtitle: "Contractors in Civil and Infrastructure Projects...",
  keyTraits: [
    {
      title: "Civil & Infrastructure Focus",
      value:
        "That work on sitework, infrastructure, and large scale civil works",
    },
    {
      title: "Work Acquisition Channels",
      value:
        "That rely on bid boards, GC networks, and repeat clients to find work",
    },
    {
      title: "Bid Management Demands",
      value:
        "That must manage multiple bids and tight timelines while staying competitive",
    },
    {
      title: "Technically Complex Projects",
      value:
        "That take on challenging scopes requiring deep civil expertise and strategic support",
    },
  ],
  challengesTitle: "Common Challenges Our Contractors Face",
  challenges: [
    {
      icon: "GpsFixedIcon",
      title: "Too Many Hats",
      value:
        "Overstretched between the field and the office, wearing too many hats",
    },
    {
      icon: "PersonOffIcon",
      title: "Talent Shortage",
      value: "A scarcity of talented estimators in the area",
    },
    {
      icon: "TrendingDownIcon",
      title: "Profit & Win Rate Struggles",
      value: "Inconsistent profit margins or win rates under pressure",
    },
    {
      icon: "EngineeringIcon",
      title: "Scaling Challenges",
      value: "Want to grow, but lack systems and support to do so sustainably",
    },
  ],
};

export default WhoWeHelpContent;
